import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm10.929 14.467-.383.924', key: 'hdyevy' }],
  ['path', { d: 'M10.929 8.923 10.546 8', key: '1nr44d' }],
  ['path', { d: 'M13.225 8.923 13.608 8', key: 'aewley' }],
  ['path', { d: 'm13.607 15.391-.382-.924', key: 'm37gf1' }],
  ['path', { d: 'm14.849 10.547.923-.383', key: '1d3c4q' }],
  ['path', { d: 'm14.849 12.843.923.383', key: 'lmvhy3' }],
  [
    'path',
    {
      d: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z',
      key: 'oel41y',
    },
  ],
  ['path', { d: 'm9.305 10.547-.923-.383', key: '1d13ox' }],
  ['path', { d: 'm9.305 12.843-.923.383', key: '7wxwh5' }],
  ['circle', { cx: '12.077', cy: '11.695', r: '3', key: 'fse9k8' }],
];

/**
 * @component @name ShieldCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAuOTI5IDE0LjQ2Ny0uMzgzLjkyNCIgLz4KICA8cGF0aCBkPSJNMTAuOTI5IDguOTIzIDEwLjU0NiA4IiAvPgogIDxwYXRoIGQ9Ik0xMy4yMjUgOC45MjMgMTMuNjA4IDgiIC8+CiAgPHBhdGggZD0ibTEzLjYwNyAxNS4zOTEtLjM4Mi0uOTI0IiAvPgogIDxwYXRoIGQ9Im0xNC44NDkgMTAuNTQ3LjkyMy0uMzgzIiAvPgogIDxwYXRoIGQ9Im0xNC44NDkgMTIuODQzLjkyMy4zODMiIC8+CiAgPHBhdGggZD0iTTIwIDEzYzAgNS0zLjUgNy41LTcuNjYgOC45NWExIDEgMCAwIDEtLjY3LS4wMUM3LjUgMjAuNSA0IDE4IDQgMTNWNmExIDEgMCAwIDEgMS0xYzIgMCA0LjUtMS4yIDYuMjQtMi43MmExLjE3IDEuMTcgMCAwIDEgMS41MiAwQzE0LjUxIDMuODEgMTcgNSAxOSA1YTEgMSAwIDAgMSAxIDF6IiAvPgogIDxwYXRoIGQ9Im05LjMwNSAxMC41NDctLjkyMy0uMzgzIiAvPgogIDxwYXRoIGQ9Im05LjMwNSAxMi44NDMtLjkyMy4zODMiIC8+CiAgPGNpcmNsZSBjeD0iMTIuMDc3IiBjeT0iMTEuNjk1IiByPSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shield-cog
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const ShieldCog = createLucideIcon('shield-cog', __iconNode);

export default ShieldCog;
